/** Matches all full tags like `{{courseTitle}}` */
export const TEMPLATE_TAG_REGEX = /{{[a-zA-Z.]+}}/g;

/** Matches a tag name like `courseTitle` in `{{courseTitle}}` */
export const TEMPLATE_TAG_NAME_REGEX = /^{{([a-zA-Z.]+)}}$/;

/** For String.split — capturing group keeps the tags in the result */
export const TEMPLATE_TAG_SPLIT_REGEX = /({{[a-zA-Z.]+}})/g;
